import { useAuthContext } from "@/features/auth/contexts/auth-context";
import { SetInitialMonetizacionMutation } from "@/features/monetizacion/api/set-initial-monetizacion";
import InitialMonetizacionForm, { initialMonetizacionFormSchema } from "@/features/monetizacion/components/initial-monetizacion-form";
import { notify } from "@/shared/notification";
import { Permiso } from "@/shared/types/permiso";
import { Container, Stack, Typography } from "@mui/material";
import ErrorPage from "../error";
import { SchemaFormHook } from "@/components/form";

export default function InitialMonetizacionPage() {
    const hasPermiso = useAuthContext().hasPermisos(Permiso.ManageMonetizacion);

    if (!hasPermiso) return <ErrorPage.Content
        status={403}
        title={"No autorizado"}
        message={"No tienes los permisos necesarios para ver este contenido."}
    />

    return <Container component={Stack} maxWidth="md" paddingTop={5} gap={3}>
        <Typography variant="h5">Definir Monedas</Typography>
        <Typography component="h2" variant="body1" color="text.secondary">
            Defina las monedas ha utilizar.
        </Typography>
        <SetInitialMonetizacionMutation>
            {mutation => <SchemaFormHook
                schema={initialMonetizacionFormSchema}
                onSubmit={async ({ value }) => {
                    await mutation.mutateAsync(value);
                    notify("Las monedas se han configurado correctamente.")
                }}
                defaultValues={{
                    monedas: [{
                        nombre: "",
                        simbolo: "",
                        base: true,
                        relacionConBase: 1,
                    }]
                }}
                submitOnce
            >
                {form => <InitialMonetizacionForm form={form} />}
            </SchemaFormHook>}
        </SetInitialMonetizacionMutation>
    </Container>
}